function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Walk",
  strokeDasharray: "none",
  strokeOpacity: 1,
  fill: "none",
  stroke: "none",
  fillOpacity: 1
}, /*#__PURE__*/React.createElement("title", null, "Walk"), /*#__PURE__*/React.createElement("g", {
  id: "Walk: Layer 1"
}, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("g", {
  id: "Group_2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Graphic_4"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 79.57789,
  cy: 25.4,
  r: 25.4000405867082,
  fill: "#293032"
})), /*#__PURE__*/React.createElement("g", {
  id: "Graphic_3"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 158.47789 99.6 C 148.67789 95.8 139.37789 90.7 130.87789 84.5 C 123.17789 78.9 116.17789 72.4 109.87789 65 C 107.37789 62.1 103.87789 60.5 99.97789 60.5 C 97.57789 60.5 95.17789 60.5 92.77789 60.5 C 92.17789 60.5 91.67789 60.6 91.17789 60.6 L 67.57789 60.6 C 64.27789 60.2 60.97789 60.2 57.67789 60.6 C 35.57789 63.3 22.67789 81.9 15.77789 92.1 C 8.67789 102.5 3.47789 114.2 .37789 126.8 C -1.32211 133.6 2.87789 140.4 9.67789 142.1 C 10.67789 142.3 11.67789 142.5 12.67789 142.5 C 18.37789 142.5 23.47789 138.6 24.97789 132.9 C 27.37789 123.2 31.27789 114.4 36.77789 106.4 C 40.37789 101.1 45.27789 94 51.47789 89.7 C 52.87789 110.8 52.77789 132 50.87789 152.8 L 50.27789 159.8 L 45.77789 177.2 C 42.87789 188.5 36.67789 198.5 27.97789 206.2 L 14.27789 218.2 C 8.97789 222.8 8.47789 230.8 13.07789 236 C 17.67789 241.3 25.67789 241.8 30.87789 237.2 L 44.57789 225.2 C 57.17789 214.1 66.07789 199.7 70.17789 183.5 L 72.37789 174.8 L 89.17789 174.8 L 94.77789 193.9 C 96.77789 200.7 97.87789 207.9 97.87789 215 L 97.87789 240.5 C 97.87789 247.5 103.57789 253.1 110.47789 253.1 C 117.37789 253.1 123.07789 247.4 123.07789 240.5 L 123.07789 215 C 123.07789 205.4 121.67789 195.8 118.97789 186.7 L 111.07789 160.1 L 109.97789 133.2 C 109.47789 122.5 109.47789 111.4 109.87789 100.3 C 111.87789 101.9 113.87789 103.5 115.97789 105 C 126.27789 112.5 137.47789 118.7 149.37789 123.2 C 150.87789 123.8 152.37789 124.1 153.97789 124.1 C 159.07789 124.1 163.87789 121 165.77789 116 C 168.1779 109.5 164.97789 102.1 158.47789 99.6 Z",
  fill: "#293032"
})))));

var SvgWalk = function SvgWalk(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "-5 -5 171.5736 260.1",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWalk, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Walk.20ff048b.svg";
export { ForwardRef as ReactComponent };